import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from '@/components/common/Select/Select';
import { FormGroupProps } from './types';
import { translateMerchandiseProductType } from '@/helpers/translateProductType';

type Props = FormGroupProps & {
  merchandiseTypes: any[];
  loadMerchandiseTypes: (inputText: string | null, callback: any) => void;
  handleMerchandiseMetadata: (field: string, value: any) => void;
};

export default function MerchandiseTypeFormGroup({
  album,
  readonly,
  disabled,
  merchandiseTypes,
  loadMerchandiseTypes,
  fieldHasErrors,
  findErrorMessage,
  handleMerchandiseMetadata,
}: Props) {
  const { t } = useTranslation();
  const selectedMerchandiseType = album.merchandiseMetadata?.merchandiseType;
  const initialMerchandiseTypeOption = merchandiseTypes?.find(
    (merchandiseType) =>
      merchandiseType.value?.id === selectedMerchandiseType?.id
  );
  const initialOption = initialMerchandiseTypeOption
    ? {
        ...initialMerchandiseTypeOption,
        label:
          translateMerchandiseProductType(initialMerchandiseTypeOption.label) ??
          initialMerchandiseTypeOption.label,
      }
    : undefined;

  return (
    <div className="form-group">
      {(merchandiseTypes?.length ?? 0) > 0 && (
        <Select
          id="merchandiseTypeTypeahead"
          labelTitle={t('product.editProduct.subType')}
          labelClass="col-sm-3 form-label"
          isClearable={!disabled}
          loadOptions={loadMerchandiseTypes}
          placeholder=""
          onChange={(e: any) => {
            handleMerchandiseMetadata('merchandiseType', e?.value);
          }}
          initialOption={initialOption}
          className="col-sm-6"
          isDisabled={disabled}
          isReadOnly={readonly}
          hasErrors={fieldHasErrors('MerchandiseType')}
          errorMessage={findErrorMessage('MerchandiseType')}
        ></Select>
      )}
    </div>
  );
}
